const PLAY_HEADER = [0xf7, 0x55]
const PLAY_FOOTER = [0xe8, 0xc5]

const ZING_PLAY_COMMAND = {
    ATTENTION: 0x55,
    DO_ACTION: 0x56,
    DO_DANCE: 0x58,
    MOVE_DIR: 0x59,
    DO_CUSTOM_ACTION: 0x60,
    GET_ALL_DANCE_NAME: 0x61,
}

const ZING_ACTION_ID = {
    KICK_LEFT: 0,
    KICK_RIGHT: 1,
    SALUTE: 2,
    APPLE_DANCE: 3,
    SQUAT: 4,
    WAVE: 5,
    BOX_FORWARD: 6,
    BOW: 7,
    PUSH_UP: 8,
    SIDE_KICK_LEFT: 9,
    SIDE_KICK_RIGHT: 10,
    SLIDE_LEFT: 11,
    SLIDE_RIGHT: 12,
}

const ZING_DANCE_ID = { MOVING: 0, IBICF: 1, SAAMI: 2, SREEVALI: 3 }

const ZING_MOVE_DIR = { FORWARD: 1, BACKWARD: 2, LEFT: 3, RIGHT: 4 }

// [F7][55][LEN1][LEN2][COMMAND][DATA...][E8][C5]; LEN = 16-bit big-endian count of DATA only (COMMAND excluded)
const buildZingPlayFrame = (command, data = []) => [
    ...PLAY_HEADER,
    (data.length >> 8) & 0xff,
    data.length & 0xff,
    command,
    ...data,
    ...PLAY_FOOTER,
]

const action = (id) => buildZingPlayFrame(ZING_PLAY_COMMAND.DO_ACTION, [id])
const dance = (id) => buildZingPlayFrame(ZING_PLAY_COMMAND.DO_DANCE, [id])
const move = (dir) => buildZingPlayFrame(ZING_PLAY_COMMAND.MOVE_DIR, [dir])

// Keys are the upper-cased Remote action names. Actions absent here have no spec entry and stay on ZingByteCodes.
const ZingPlayFrames = {
    ATTENTION: buildZingPlayFrame(ZING_PLAY_COMMAND.ATTENTION),
    ATTENTIONMID: buildZingPlayFrame(ZING_PLAY_COMMAND.ATTENTION),
    STOP: buildZingPlayFrame(ZING_PLAY_COMMAND.ATTENTION),

    // Verified on robot: spec IDs 0/1 (KICK) perform the side kick and 9/10 (SIDE_KICK) the front kick.
    SIDEKICKLEFT: action(ZING_ACTION_ID.KICK_LEFT),
    SIDEKICKRIGHT: action(ZING_ACTION_ID.KICK_RIGHT),
    FRONTKICKLEFT: action(ZING_ACTION_ID.SIDE_KICK_LEFT),
    FRONTKICKRIGHT: action(ZING_ACTION_ID.SIDE_KICK_RIGHT),
    SLIDELEFT: action(ZING_ACTION_ID.SLIDE_LEFT),
    SLIDERIGHT: action(ZING_ACTION_ID.SLIDE_RIGHT),
    FIGHT: action(ZING_ACTION_ID.BOX_FORWARD),
    DANCE: action(ZING_ACTION_ID.APPLE_DANCE),
    SALUTE: action(ZING_ACTION_ID.SALUTE),
    SQUAT: action(ZING_ACTION_ID.SQUAT),
    WAVE: action(ZING_ACTION_ID.WAVE),
    BOW: action(ZING_ACTION_ID.BOW),
    PUSHUP: action(ZING_ACTION_ID.PUSH_UP),

    DANCE1: dance(ZING_DANCE_ID.MOVING),
    DANCE2: dance(ZING_DANCE_ID.IBICF),
    DANCE3: dance(ZING_DANCE_ID.SAAMI),
    DANCE4: dance(ZING_DANCE_ID.SREEVALI),

    MOVEFORWARD: move(ZING_MOVE_DIR.FORWARD),
    MOVEBACKWARD: move(ZING_MOVE_DIR.BACKWARD),
    MOVELEFT: move(ZING_MOVE_DIR.LEFT),
    MOVERIGHT: move(ZING_MOVE_DIR.RIGHT),
}

// Framed play protocol: firmware 2.0.x-2.2.x and all 3.x.
const isZingPlayFrameVersion = (connectedDevice, deviceVersion) => {
    if (connectedDevice !== 'Humanoid') return false
    const [major, minor] = (deviceVersion ?? '').split('.').map(Number)
    if (major === 3) return true
    return major === 2 && minor <= 2
}

const isZingPlayFrame = (data) =>
    Array.isArray(data) && data[0] === PLAY_HEADER[0] && data[1] === PLAY_HEADER[1]

// Request frame for GET_ALL_DANCE_NAME (0x61): no data, per the protocol sheet.
const GET_ALL_DANCE_NAMES_FRAME = buildZingPlayFrame(
    ZING_PLAY_COMMAND.GET_ALL_DANCE_NAME
)

// DATA is alternating ID/NAME lines, e.g. "0\nMOVING\n1\nSAAMI\n...".
const parseGetAllDanceNamesFrame = (bytes) => {
    if (!Array.isArray(bytes) || bytes.length < 7) return null
    if (bytes[0] !== PLAY_HEADER[0] || bytes[1] !== PLAY_HEADER[1]) return null
    const dataLen = (bytes[2] << 8) | bytes[3]
    const command = bytes[4]
    if (command !== ZING_PLAY_COMMAND.GET_ALL_DANCE_NAME) return null
    if (bytes.length !== 5 + dataLen + 2) return null
    if (
        bytes[bytes.length - 2] !== PLAY_FOOTER[0] ||
        bytes[bytes.length - 1] !== PLAY_FOOTER[1]
    )
        return null

    const data = bytes.slice(5, 5 + dataLen)
    const raw = String.fromCharCode(...data)
    const lines = raw
        .split('\n')
        .map((line) => line.replace(/\r/g, '').trim())
        .filter((line) => line.length > 0)

    const result = []
    for (let i = 0; i + 1 < lines.length; i += 2) {
        const index = Number(lines[i])
        const name = lines[i + 1]
        if (Number.isInteger(index) && name.length > 0) {
            result.push({ index, name })
        }
    }
    return result
}

export {
    ZING_PLAY_COMMAND,
    ZingPlayFrames,
    ZING_DANCE_ID,
    buildZingPlayFrame,
    isZingPlayFrameVersion,
    isZingPlayFrame,
    GET_ALL_DANCE_NAMES_FRAME,
    parseGetAllDanceNamesFrame,
}
